import React from 'react'
import { useTranslation } from 'react-i18next'

import { IColumn } from '@cbgms/components/grid/Types'
import { IStructure } from '@cbgms/api/response'
import ColumnSettingsDialog from './ColumnSettingsDialog'
import { KnockTypes } from '@cbgms/components/grid/Knock/KnockTypes'

export interface IWithColumnSettingsProps {
  headers: IColumn[]
  structure: IStructure
  hideUUIDColumns: boolean
  onSettingAdd: (column: string, type: KnockTypes) => Promise<void>
  onSettingRemove: (columnName: string) => Promise<void>
  onSettingsReset: () => Promise<void>
  onSettingsDisplay: (column: string) => string
  onResetFilters: () => Promise<void>
  hideColumnSettings?: boolean
}

function WithColumnSettings(WrappedComponent: React.ComponentType<any>) {
  function ColumnSettings(props: IWithColumnSettingsProps) {
    const { t } = useTranslation()
    const [showColumnSettings, setShowColumnSettings] = React.useState(() => {
      return props.headers.every(header => header.static)
    })

    if (props.hideColumnSettings) {
      return <WrappedComponent {...props} />
    }

    const menuItems = [
      {
        icon: 'grid layout',
        title: t('ColumnSettings.TooltipSelectColumns'),
        action: () => setShowColumnSettings(true)
      },
      {
        text: t('ColumnSettings.Reset'),
        action: props.onResetFilters
      }
    ]

    return showColumnSettings ? (
      <ColumnSettingsDialog
        hideUUIDColumns={props.hideUUIDColumns}
        open={showColumnSettings}
        structure={props.structure}
        activeColumns={props.headers.filter(column => !column.static).map(header => header.key)}
        onSettingAdd={props.onSettingAdd}
        onSettingRemove={props.onSettingRemove}
        onSettingsReset={props.onSettingsReset}
        onSettingsDisplay={props.onSettingsDisplay}
        onClose={() => setShowColumnSettings(false)}
      />
    ) : (
      <WrappedComponent {...props} menuItems={menuItems} />
    )
  }

  return ColumnSettings
}

export default WithColumnSettings
